module.exports = __webpack_public_path__ + "static/media/art12.93c4909f.png";